document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.faq-item').forEach(item => {
    const button = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    if (!button || !answer) return;

    button.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      // Cerrar los demás (opcional)
      document.querySelectorAll('.faq-item.is-open').forEach(openItem => {
        if (openItem !== item) closeItem(openItem);
      });

      isOpen ? closeItem(item) : openItem(item);
    });
  });

  function openItem(el) {
    const answer = el.querySelector('.faq-answer');
    const button = el.querySelector('.faq-question');
    el.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    answer.setAttribute('aria-hidden', 'false');
    answer.style.height = answer.scrollHeight + 'px';
  }

  function closeItem(el) {
    const answer = el.querySelector('.faq-answer');
    const button = el.querySelector('.faq-question');
    el.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
    answer.setAttribute('aria-hidden', 'true');
    answer.style.height = 0;
  }

  // Lista de conectores que no aportan valor al filtrado de palabras clave (es/esca).
  const STOP_WORDS = new Set([
    // Español
    'de', 'la', 'que', 'el', 'en', 'y', 'a', 'los', 'del', 'se', 'las', 'por', 'un',
    'para', 'con', 'no', 'una', 'su', 'al', 'lo', 'como', 'más', 'o', 'pero', 'sus',
    'le', 'ya', 'porque', 'esta', 'desde', 'todo', 'cuando', 'muy', 'sin', 'sobre',
    'también', 'me', 'hasta', 'donde', 'quien', 'durante', 'todos', 'uno', 'les', 'ni',
    'contra', 'otros', 'ese', 'eso', 'ante', 'ellos', 'e', 'esto', 'mí', 'antes',
    'algunos', 'qué', 'unos', 'des', 'está', 'está', 'así',
    // Catalán
    'de', 'la', 'que', 'el', 'en', 'i', 'a', 'els', 'del', 'se', 'les', 'per', 'un',
    'per', 'amb', 'no', 'una', 'el', 'al', 'com', 'més', 'o', 'però', 'els',
    'ja', 'perquè', 'aquesta', 'des', 'tot', 'quan', 'molt', 'sense', 'sobre',
    'també', 'em', 'fins', 'on', 'qui', 'durant', 'tots', 'un', 'els', 'ni',
    'contra', 'altres', 'aquell', 'això', 'abans', 'ells', 'i', 'això', 'a mi',
    'abans', 'alguns', 'què', 'uns'
  ]);

  const normalize = text => (text || '').toLowerCase().trim();

  // Genera un arreglo de keywords relevantes excluyendo stop words y tokens cortos.
  const extractKeywords = value =>
    value
      .split(/\s+/)
      .map(normalize)
      .filter(word => word.length > 1 && !STOP_WORDS.has(word));

  // Inicializa el buscador para cada input registrado en la sección.
  document.querySelectorAll('[data-faq-search-input]').forEach(input => {
    const sectionId = input.dataset.faqSearchInput;
    const container = document.querySelector(`.faqs[data-faq-section="${sectionId}"]`);
    const button = document.querySelector(`[data-faq-search-button="${sectionId}"]`);
    if (!container) return;

    const heading =
      document.getElementById(`faq-heading-${sectionId}`) ||
      container.querySelector('.wrapper h2');

    const filterFaqs = () => {
      const keywords = extractKeywords(input.value);
      const categories = container.querySelectorAll('.faq-category');
      const hasKeywords = keywords.length > 0;

      // Por cada categoría se revisan los ítems y se actualiza su visibilidad.
      categories.forEach(category => {
        const accordion = category.querySelector('.faq-accordion');
        if (!accordion) return;

        let categoryHasMatch = false;

        accordion.querySelectorAll('.faq-item').forEach(item => {
          const question = item.querySelector('.faq-question__text');
          const text = normalize(question ? question.textContent : '');
          const isMatch = !hasKeywords || keywords.some(keyword => text.includes(keyword));
          item.style.display = isMatch ? '' : 'none';
          if (isMatch) categoryHasMatch = true;
        });

        const children = Array.from(accordion.children);
        let currentTitle = null;
        let currentTitleHasMatch = false;

        children.forEach(child => {
          if (child.classList.contains('faq-title')) {
            if (currentTitle) {
              currentTitle.style.display = currentTitleHasMatch ? '' : 'none';
            }
            currentTitle = child;
            currentTitleHasMatch = false;
            return;
          }

          if (child.classList.contains('faq-item') && child.style.display !== 'none') {
            currentTitleHasMatch = true;
          }
        });

        if (currentTitle) {
          currentTitle.style.display = currentTitleHasMatch ? '' : 'none';
        }

        category.style.display = categoryHasMatch ? '' : 'none';
      });

    };

    const scrollToHeading = () => {
      if (heading) {
        heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    if (button) {
      // El botón dispara la búsqueda y el scroll.
      button.addEventListener('click', () => {
        filterFaqs();
        scrollToHeading();
        input.focus();
      });
    }

    input.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        event.preventDefault();
        filterFaqs();
        if (heading) {
          heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });
});